<template>
    <div>
        <el-form :inline="true" :model="query" class="query-form" size="mini">
            <el-form-item class="query-form-item">
                <el-input v-model="query.roleName" placeholder="Role Name"></el-input>
            </el-form-item>
            <el-form-item class="query-form-item">
                <el-select v-model="query.status" placeholder="Status">
                    <el-option label="All" value=""></el-option>
                    <el-option label="Disable" value="0"></el-option>
                    <el-option label="Normal" value="1"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item>
                <el-button-group>
                    <el-button type="primary" icon="el-icon-refresh" @click="onReset"></el-button>
                    <el-button type="primary" icon="search" @click="onSubmit">Query</el-button>
                    <el-button type="primary" v-if="authRulesFun('admin/auth/role/save')" @click.native="handleForm(null,null)">Add</el-button>
                </el-button-group>
            </el-form-item>
        </el-form>
        <el-scrollbar class="table-scrollbar" wrap-style="overflow-x: hidden;">
            <el-table v-loading="loading" :data="list" style="width: 100%;">
                <el-table-column label="No."  type="index" width="50">
                </el-table-column>
                <el-table-column
                    label="Role Name"
                    prop="roleName">
                </el-table-column>
                <el-table-column
                    label="Status">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.status | statusFilterType">{{scope.row.status | statusFilterName}}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column
                    label="Remark"
                    :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <span>{{ scope.row.remark }}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="Operation"
                    fixed="right"
                    width="200" v-if="authRulesFun('admin/auth/role/auth')||authRulesFun('admin/auth/role/edit')||authRulesFun('admin/auth/role/delete')">
                    <template slot-scope="scope" >
                        <el-button type="text" size="small" v-if="authRulesFun('admin/auth/role/auth')" @click.native="handleAuth(scope.row.id)">Permission</el-button>
                        <el-button type="text" size="small" v-if="authRulesFun('admin/auth/role/edit')" @click.native="handleForm(scope.$index, scope.row)">Edit</el-button>
                        <el-button type="text" size="small" v-if="authRulesFun('admin/auth/role/delete')" @click.native="handleDel(scope.$index, scope.row)" :loading="deleteLoading">Delete</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-scrollbar>

        <el-pagination
            :page-size="query.limit"
            @current-change="handleCurrentChange"
            layout="total,prev, pager, next"
            :total="total">
        </el-pagination>

        <!--Authorization interface-->
        <el-dialog
            title="Permission"
            :visible.sync="authFormVisible"
            :close-on-click-modal="false"
            class="dialog">
            <el-tree
                style="max-height: 75vh;overflow-y: auto;"
                :data="authList"
                show-checkbox=""
                default-expand-all=""
                node-key="id"
                ref="tree"
                :props="defaultProps"
                :default-checked-keys="authDefaultCheckedKeys">
            </el-tree>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="authFormVisible = !authFormVisible">Cancel</el-button>
                <el-button type="primary" @click.native="authSubmit()" :loading="authLoading">Save
                </el-button>
            </div>
        </el-dialog>

        <!--form-->
        <el-dialog
            :title="formMap[formName]"
            :visible.sync="formVisible"
            :before-close="hideForm"
            width="85%"
            top="5vh">
            <el-form :model="formData" :rules="formRules" ref="dataForm">
                <el-form-item label="Role Name" prop="roleName">
                    <el-input v-model.trim="formData.roleName" maxlength="60" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="Sort" prop="listorder">
                    <el-input type="" maxlength="20" v-model="formData.listorder" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="Status" prop="status">
                    <el-radio-group v-model="formData.status">
                        <el-radio :label="0">Disable</el-radio>
                        <el-radio :label="1">Normal</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="Remark">
                    <el-input type="textarea" maxlength="100" v-model="formData.remark"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="hideForm">Cancel</el-button>
                <el-button type="primary" @click.native="formSubmit()" :loading="formLoading">Save</el-button>
            </div>
        </el-dialog>
    </div>

</template>

<script>
import {
    authRoleList,
    authRoleAuthList,
    authRoleAuth,
    authRoleSave,
    authRoleDelete
} from "../../../api/auth/authRole";
const formJson = {
    id: "",
    roleName: "",
    status: 1,
    remark: "",
    listorder: 50
};
export default {
    data() {
        var validatorSort = (rule, value, callback) => {
            var reg = /^[0-9]*$/;
            if(!reg.test(value)){
                callback(new Error('Sort must be a numeric value'));
            }else if (value>1000) {
                callback(new Error('Max 1000'));
            } else {
                callback();
            }
        };
        return {
            authRules:this.$store.state.admin.authRules,
            query: {
                roleName: "",
                status: "",
                page: 1,
                limit: 20
            },
            list: [],
            total: 0,
            loading: true,
            authList: [],
            defaultProps: {
                children: "children",
                label: "title"
            },
            authLoading: false,
            authFormVisible: false,
            authFormData: {
                roleId: "",
                authRules: []
            },
            authDefaultCheckedKeys: [],
            index: null,
            formName: null,
            formMap: {
                Add: "Add",
                Edit: "Edit"
            },
            formLoading: false,
            formVisible: false,
            formData: formJson,
            formRules: {
                roleName: [
                    { required: true, message: "Please enter a name", trigger: "blur" }
                ],
                listorder:[
                    { type: 'number', validator:validatorSort, trigger: "change"},
                ],
                status: [
                    { required: true, message: "Please select a status", trigger: "change" }
                ]
            },
            deleteLoading: false
        };
    },
    methods: {
        authRulesFun(url){
            if(this.authRules.length==1 && this.authRules[0]=='admin'){
                return true
            }
            var status = false
            for(var a=0;a<this.authRules.length;a++){
                if(this.authRules[a]==url){
                    status = true
                    break;
                }else {
                    status = false
                }
            }
            return status
        },
        onReset() {
            this.$router.push({
                path: ""
            });
            this.query = {
                roleName: "",
                status: "",
                page: 1,
                limit: 20
            };
            this.getList();
        },
        onSubmit() {
            this.getList();
        },
        handleCurrentChange(val) {
            this.query.page = val;
            this.getList();
        },
        getList() {
            this.loading = true;
            authRoleList(this.query)
                .then(response => {
                    this.loading = false;
                    if (response.code) {
                        this.$message.error(response.message);
                    }
                    this.list = response.data.list || [];
                    this.total = response.data.total || 0;
                })
                .catch(() => {
                    this.loading = false;
                    this.list = [];
                    this.total = 0;
                });
        },
        // Display authorization interface
        handleAuth(roleId) {
            this.authFormData.roleId = roleId;
            this.authFormData.authRules = [];
            this.authList = [];
            authRoleAuthList({ id: roleId })
                .then(response => {
                    if (response.code) {
                        this.authFormVisible = false;
                        this.$message({
                            message: response.message,
                            type: "error"
                        });
                        return;
                    }
                    this.authFormVisible = true;
                    this.authList = response.data.list || [];
                    const checkedKeys = response.data.checkedKeys || [];
                    let tempCheckedKeys = [];
                    let id = null;
                    let node = null;
                    let getTreeNode = function(arr, id) {
                        for (let i in arr) {
                            let tempNode = arr[i];
                            if (tempNode.id === id) {
                                node = tempNode;
                            }
                            getTreeNode(tempNode.children, id);
                        }
                    };
                    for (let i in checkedKeys) {
                        id = checkedKeys[i];
                        getTreeNode(this.authList, id);
                        if (node && node.children.length <= 0) {
                            tempCheckedKeys.push(id);
                        }
                    }
                    this.authDefaultCheckedKeys = [];
                    this.authDefaultCheckedKeys = tempCheckedKeys;
                    // this.$refs.tree.setCheckedKeys(tempCheckedKeys);
                })
                .catch(() => {});
        },
        authSubmit() {
            this.authLoading = true;
            let getNodeParents = function(node) {
                let arr = [];
                let id = node.data.id || null;
                if (id) {
                    arr.push(node.data.id);
                }
                if (node.parent) {
                    arr = arr.concat(getNodeParents(node.parent));
                }
                return arr;
            };
            let checkedKeys = this.$refs.tree.getCheckedKeys();
            let arr = [];
            for (let checkedKey of checkedKeys) {
                let node = this.$refs.tree.getNode(checkedKey);
                arr = arr.concat(getNodeParents(node));
            }
            let setArr = new Set(arr);
            this.authFormData.authRules = [...setArr];
            if (!this.authFormData) {
                this.$alert("Please select at least one permission", "Tips", {
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                });
                return false;
            }
            authRoleAuth(this.authFormData)
                .then(response => {
                    this.authLoading = false;
                    if (response.code) {
                        this.$message.error(response.message);
                        return false;
                    }
                    this.$message.success("Successfully");
                    // updata form
                    this.authFormVisible = false;
                })
                .catch(() => {
                    this.authLoading = false;
                });
        },
        // updata form
        resetForm() {
            if (this.$refs["dataForm"]) {
                // clean form
                this.$refs["dataForm"].clearValidate();
                // updata form
                this.$refs["dataForm"].resetFields();
            }
        },
        // hide form
        hideForm() {
            // up value
            this.formVisible = !this.formVisible;
            return true;
        },
        // show form
        handleForm(index, row) {
            this.formVisible = true;
            this.formData = JSON.parse(JSON.stringify(formJson));
            if (row !== null) {
                this.formData = Object.assign({}, row);
            }
            this.formName = "Add";
            if (index !== null) {
                this.index = index;
                this.formName = "Edit";
            }
        },
        formSubmit() {
            this.$refs["dataForm"].validate(valid => {
                if (valid) {
                    this.formLoading = true;
                    let data = Object.assign({}, this.formData);
                    authRoleSave(data, this.formName)
                        .then(response => {
                            this.formLoading = false;
                            if (response.code) {
                                this.$message.error(response.message);
                                return false;
                            }
                            this.$message.success("Successfully");
                            this.formVisible = false;
                            this.onSubmit();
                        })
                        .catch(() => {
                            this.formLoading = false;
                        });
                }
            });
        },
        // delete
        handleDel(index, row) {
            if (row.id) {
                this.$confirm("Are you sure to delete this record?", "Tips", {
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    type: "warning"
                })
                    .then(() => {
                        this.deleteLoading = true;
                        let para = { id: row.id };
                        authRoleDelete(para)
                            .then(response => {
                                this.deleteLoading = false;
                                if (response.code) {
                                    this.$message.error(response.message);
                                    return false;
                                }
                                this.$message.success("Successfully");
                                // updata form
                                this.list.splice(index, 1);
                                this.total--;

                            })
                            .catch(() => {
                                this.deleteLoading = false;
                            });
                    })
                    .catch(() => {
//                        this.$message.error("Cancel");
                    });
            }
        }
    },
    filters: {
        statusFilterType(status) {
            const statusMap = {
                0: "gray",
                1: "success"
            };
            return statusMap[status];
        },
        statusFilterName(status) {
            const statusMap = {
                0: "Disable",
                1: "Normal"
            };
            return statusMap[status];
        }
    },
    mounted() {},
    created() {
        this.getList();
    }
};
</script>

<style type="text/scss" lang="scss">
</style>
